module.exports = __webpack_public_path__ + "img/options.9c483b80.svg";